module.exports = __webpack_public_path__ + "static/partner-watchguard-5c9c780d9b068e2e1ad30d95659bc845.jpg";